import BinToRatioConverter from "./BinToRatioConverter.js";

class BinToPercentConverter extends BinToRatioConverter {
    _determineRatio(quantity, total) {
        return 100 * (quantity / total);
    }
}

export default BinToPercentConverter;